import type { AsyncableFunc } from '@ricoh/ria.client.core/types/core/function.type';

import DateTime from '@ricoh/ria.client.core/plugins/moment';
import { normalizeObject } from '@ricoh/ria.client.core/utils/data/object';
import { base64 } from '@ricoh/ria.client.core/utils/encrypt/base64';
import axios from 'axios';

import type { LabOptions } from './_lab.type';

import { debug } from './_debugger';

const globalThisCore = globalThis as GlobalThisCore;

/**
 * Init Lab plugin.
 *
 * @param {AsyncableFunc<LabOptions>} createOptions Create options.
 */
export default async function init(createOptions: AsyncableFunc<[], LabOptions>) {
  globalThisCore.lab = {
    app: APP_BUILD_VERSION,
  };

  if (import.meta.env.PROD) {
    return;
  }

  const { store, service } = await Promise.resolve(createOptions());
  globalThisCore.lab = {
    ...globalThisCore.lab,

    env: import.meta.env,

    service,

    lib: {
      axios,
      DateTime,
    },

    utils: {
      base64,
      normalizeObject,
    },

    store: (path: string = '') => {
      const state = store.getState();
      if (!path) {
        return state;
      }

      return path.split('.').reduce<Record<string, unknown> | undefined>((prev, key) => {
        if (prev?.[key] === undefined) {
          return undefined;
        }

        return prev[key] as Record<string, unknown>;
      }, state);
    },

    debug,
  };
}
